export default __webpack_public_path__ + "static/media/logo.e326db43.svg";